import { getCurriculum, getOnboarding } from '../../content/curriculum';

/**
 * The typical use-case for a `selector` from the reselect library is to create a memo-ized function for reading the
 * Redux store. We are adapting that use case here to create "getter" functions that access the curriculum json
 * NOTE: these are not truly "selectors" because they are not memo-ized.
 */

export const getClaimsInLevelSide = (levelIndex, sideIndex) => (
  getCurriculum().levels[levelIndex][sideIndex]
);

export const getClaim = (levelIndex, sideIndex, claimIndex) => (
  levelIndex < 0
    ? getClaimsInLevelSide(0, 0)[0]
    : getClaimsInLevelSide(levelIndex, sideIndex)[claimIndex]
);

export const getClaimText = (levelIndex, sideIndex, claimIndex) => (
  levelIndex < 0
    ? getOnboarding().text
    : getClaim(levelIndex, sideIndex, claimIndex).text
);

export const getUserEvidenceOptions = (levelIndex, sideIndex, claimIndex, itemIndex) => (
  levelIndex < 0
    ? getOnboardingOptions(itemIndex)
    : getClaim(levelIndex, sideIndex, claimIndex).userEvidence[itemIndex]
);

export const getCorrectResponse = (levelIndex, sideIndex, claimIndex, itemIndex) => (
  getUserEvidenceOptions(levelIndex, sideIndex, claimIndex, itemIndex).find(item => item.isCorrect === true)
);

export const getComputerEvidence = (levelIndex, sideIndex, claimIndex, itemIndex) => (
  levelIndex < 0
    ? {} // no computer evidence in onboarding
    : getClaim(levelIndex, sideIndex, claimIndex).computerEvidence[itemIndex]
);

export const getComputerEvidenceText = (levelIndex, sideIndex, claimIndex, itemIndex) => (
  levelIndex < 0
    ? '' // no computer evidence in onboarding
    : getComputerEvidence(levelIndex, sideIndex, claimIndex, itemIndex).text
);

export const getComputerEvidenceIsCorrect = (levelIndex, sideIndex, claimIndex, itemIndex) => (
  levelIndex < 0
    ? false // no computer evidence in onboarding
    : getComputerEvidence(levelIndex, sideIndex, claimIndex, itemIndex).isCorrect
);

export const getOnboardingOptions = onboardingItemIndex => (
  getOnboarding().userEvidence[onboardingItemIndex]
);

export const getOnboardingClaimText = (
  getOnboarding().text
);
